import React from 'react';
import Button from '@material-ui/core/Button';
import Loading from 'components/pure/utils/Loading';
import DepartmentProfileList from './DepartmentProfileList';
import CardProfilesPageHelp from './CardProfilesPageHelp';
import {Link} from 'react-router';

export default class CardProfilesPage extends React.PureComponent {
  render() {
    const {wasError, isLoading, cardProfiles} = this.props.CardProfileStore;
    const {department, isDepartmentSaving} = this.props.DepartmentFormStore;
    return (
      <div className="filter-words-profiles-page">
        <h1>Scorecard Profiles</h1>
        <CardProfilesPageHelp
          department={department}
          hasDepartmentContext={this.props.hasDepartmentContext}
          cardProfiles={cardProfiles}
        />
        <p>
          A scorecard profile defines which scorecards are available for your users. Each department
          can have a different profile.
        </p>
        <div className="button-container">
          <Button
            component={Link}
            variant="contained"
            color="primary"
            className="ev-button"
            to={window.location.pathname + '/new'}>
            New Scorecard Profile
          </Button>
        </div>
        {wasError ? (
          'Error fetching profiles.'
        ) : isLoading ? (
          <Loading />
        ) : (
          <DepartmentProfileList
            isDepartmentSaving={isDepartmentSaving}
            profiles={cardProfiles}
            hasDepartmentContext={this.props.hasDepartmentContext}
            department={department}
            updateDepartment={this.props.DepartmentActions.updateDepartment}
            profileIdName="cardsProfileId"
          />
        )}
      </div>
    );
  }
}
